import { Card } from "../_shared/card";
import { IconImages } from "../_shared/icons";
import { navigate } from "../_shared/router";
import { photoMonths } from "../_data/mock";

export function PhotosCard() {
  const totalCount = photoMonths.reduce((sum, m) => sum + m.count, 0);
  return (
    <Card
      title="Photos"
      icon={<IconImages width={18} height={18} />}
      onClick={() => navigate("photos")}
    >
      <div className="flex items-center justify-between gap-3">
        <p className="text-[13px] text-[var(--text-2)]">
          <span className="font-semibold text-[var(--text-1)]">
            {totalCount} photos
          </span>
          <span className="text-[var(--text-2)]">
            {" "}
            sur {photoMonths.length} mois
          </span>
        </p>
        <div className="flex -space-x-1.5">
          {photoMonths.slice(0, 3).map((m) => (
            <span
              key={m.id}
              aria-hidden
              className="inline-block size-8 rounded-md bg-gradient-to-br from-gray-200 to-gray-300 ring-2 ring-white"
            />
          ))}
        </div>
      </div>
    </Card>
  );
}
